export const BORROW_OR_REPAY_TABS = {
  BORROW: { key: "borrow", index: 0, name: "Borrow" },
  REPAY: { key: "repay", index: 1, name: "Repay" },
};
